var _circle, _circle2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJaNeck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_3071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_3071)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.0004,
    cy: 29.4857,
    r: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 33.9424 26.3999)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9424,
    y: 25.3711,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(-120 33.9424 25.3711)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0566,
    y: 26.3999,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(60 14.0566 26.3999)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 14.0566 25.3711)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1585 33.361C40.0711 32.5744 38.1725 32.2372 36.4984 31.9404C32.29 31.1929 29.9451 30.7777 29.8808 24.1434C30.5005 23.6937 31.0772 23.1877 31.6035 22.6318C33.5417 20.5957 34.992 17.7812 35.6874 14.7062C35.7058 14.6352 35.7097 14.5613 35.6989 14.4888C35.6881 14.4163 35.6629 14.3467 35.6247 14.2841C35.5865 14.2216 35.5361 14.1673 35.4765 14.1246C35.4169 14.0819 35.3494 14.0515 35.2778 14.0354C35.2063 14.0193 35.1322 14.0177 35.06 14.0307C34.9879 14.0437 34.919 14.0711 34.8577 14.1112C34.7963 14.1513 34.7436 14.2033 34.7027 14.2642C34.6618 14.325 34.6336 14.3935 34.6197 14.4654C33.9668 17.3503 32.6144 19.9829 30.8102 21.8774C28.8638 23.9211 26.5087 25.0017 23.9996 25.0017C21.4906 25.0017 19.1355 23.9211 17.189 21.8774C15.3849 19.9829 14.0325 17.3503 13.3796 14.4654C13.3439 14.3278 13.2561 14.2094 13.1347 14.1354C13.0132 14.0613 12.8677 14.0374 12.729 14.0687C12.5902 14.1 12.4691 14.184 12.3912 14.303C12.3134 14.422 12.2849 14.5666 12.3119 14.7062C13.0073 17.784 14.4575 20.5957 16.3958 22.6318C16.9223 23.1875 17.4989 23.6935 18.1185 24.1434C18.0541 30.7777 15.7093 31.1929 11.5009 31.9404C9.82678 32.2372 7.92821 32.5744 5.84074 33.361C5.70461 33.4121 5.59438 33.5152 5.53431 33.6476C5.47424 33.78 5.46925 33.9308 5.52044 34.0668C5.57163 34.2029 5.6748 34.313 5.80726 34.373C5.93972 34.4331 6.09061 34.4381 6.22675 34.3869C8.21977 33.6346 10.065 33.3083 11.6925 33.019C15.8715 32.2769 18.9398 31.7311 19.1971 24.8328C20.6618 25.6617 22.3164 26.0974 23.9996 26.0974C25.6829 26.0974 27.3375 25.6617 28.8022 24.8328C29.0595 31.7311 32.1284 32.2769 36.3068 33.019C37.9343 33.3083 39.7795 33.6346 41.7725 34.3869C41.8399 34.4122 41.9117 34.424 41.9836 34.4217C42.0556 34.4193 42.1264 34.4028 42.192 34.373C42.2576 34.3433 42.3167 34.301 42.3659 34.2484C42.4151 34.1959 42.4535 34.1342 42.4788 34.0668C42.5042 33.9995 42.516 33.9278 42.5136 33.8558C42.5112 33.7839 42.4947 33.7132 42.465 33.6476C42.4352 33.5821 42.3929 33.523 42.3403 33.4738C42.2877 33.4247 42.2259 33.3863 42.1585 33.361Z",
    fill: "#536479"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaNeck);
export default __webpack_public_path__ + "static/media/ja_neck.b9e80b4aaca7323e83f10f6640785bf5.svg";
export { ForwardRef as ReactComponent };